import React from 'react';
import { useTranslations } from 'next-intl';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import Input from '@/shared/ui/input';
import { useBooking } from '../../model/store/booking';
import { fioValidation, iinValidation } from '../../utils/validations';
import { BookingAgreement } from './BookingAgreement';
import { BookingTimeSelect } from './BookingTimeSelect';
import { BookingTypeRadio } from './BookingTypeRadio';
import { InputPhone } from './InputPhone';
import inputIcons from '@/shared/assets/sprites/inputs.sprite.svg';
import type { IPayloadMakeBooking } from '@/entities/booking/model/types';
import type { UseBooking } from '../../model/store/booking';
interface Props {
  makeBookingData: IPayloadMakeBooking;
  locale: LanguageCodeEnum;
  currentBooking: UseBooking['booking'][0];
  setFieldMakeBooking: (field: keyof IPayloadMakeBooking, value: string | number) => void;
  setIsSelectOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}
export const BookingOnlineForm: React.FC<Props> = props => {
  const {
    makeBookingData,
    currentBooking,
    locale,
    setFieldMakeBooking,
    setIsSelectOpen
  } = props;
  const t = useTranslations();
  const {
    hasOnlineBooking
  } = useBooking();
  return <form className="flex w-full flex-col gap-3 md:gap-4" data-sentry-component="BookingOnlineForm" data-sentry-source-file="BookingOnlineForm.tsx">
      {currentBooking.iinRequired &&
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label>
          <Input placeholder={t('bookingPage.iin')} type="text" inputMode="numeric" className="w-full" value={makeBookingData.iin || ''} onChange={e => setFieldMakeBooking('iin', e.target.value)} maxLength={12} validations={iinValidation} data-testid={featureBookingModalConfig.ids.bookingIinInput} />
        </label>}

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="relative w-full">
        <Input placeholder={t('bookingPage.fio')} type="text" className="w-full" variant="leftIcon" value={makeBookingData.fullName || ''} onChange={e => setFieldMakeBooking('fullName', e.target.value)} validations={fioValidation} data-testid={featureBookingModalConfig.ids.bookingFioInput} data-sentry-element="Input" data-sentry-source-file="BookingOnlineForm.tsx">
          <svg className="absolute left-4 top-1/2 size-6 -translate-y-1/2 opacity-50" data-sentry-element="svg" data-sentry-source-file="BookingOnlineForm.tsx">
            <use xlinkHref={`${inputIcons}#user-profile`} data-sentry-element="use" data-sentry-source-file="BookingOnlineForm.tsx"></use>
          </svg>
        </Input>
      </label>

      <InputPhone currentPhone={makeBookingData.phoneNumber || ''} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldMakeBooking('phoneNumber', e.target.value)} testId={featureBookingModalConfig.ids.bookingPhoneInput} data-sentry-element="InputPhone" data-sentry-source-file="BookingOnlineForm.tsx" />

      <div className="px-1 empty:hidden">
        {!currentBooking.changedSlot && <BookingTimeSelect value={makeBookingData.preferredTime} onValueChange={value => setFieldMakeBooking('preferredTime', value)} onOpenChange={setIsSelectOpen} />}
      </div>

      {hasOnlineBooking && <BookingTypeRadio onValueChange={value => setFieldMakeBooking('bookingType', value)} />}

      <BookingAgreement locale={locale} data-sentry-element="BookingAgreement" data-sentry-source-file="BookingOnlineForm.tsx" />
    </form>;
};